import { axiosICPLBEInstance } from "../../../utils/axios_config";

export default function EDeliveryOrderService() {

    this.getAll = async (reqBody, signal) => {
        return axiosICPLBEInstance.post('eDo/getAll', reqBody, { signal: signal });
    }
}